import { MODES, WARN_EVERY } from './config';
import { evaluateTask } from './engine';
import { minutesUntil } from './time';
import { useAutoContinueState } from './useAutoContinue';

const tones = {
  info: { background: '#eef2ff', color: '#4338ca', border: '1px solid #c7d2fe' },
  muted: { background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0' },
  warn: { background: '#fef9c3', color: '#a16207', border: '1px solid #fde68a' },
};

export function getBadgeInfo(task, record, mode, nowMs) {
  if (mode === MODES.OFF) return null;
  const result = evaluateTask(task, record, nowMs);
  const prefix = mode === MODES.DRY ? 'Avto (sinov)' : 'Avto';
  // Hisoblagich faqat ma'lumot uchun; WARN_EVERY dan ko'p urinilgan bo'lsa — sariq rang
  const tone = result.count >= WARN_EVERY ? 'warn' : 'info';
  const attempts = result.count > 0 ? `${result.count}-urinish · ` : '';
  switch (result.state) {
    case 'waiting':
      return { tone, text: `${prefix}: ${attempts}keyingisi ${minutesUntil(result.nextAt, nowMs)} daq. ichida` };
    case 'due':
      return { tone, text: `${prefix}: ${attempts}navbatda` };
    case 'skip':
      return { tone: 'muted', text: `${prefix}: o'tkazib yuborildi (${result.reason})` };
    default:
      return null;
  }
}

// /history kartasida failed task yonidagi ma'lumot belgisi. Faqat ko'rsatadi, hech narsa yubormaydi.
export default function AutoContinueBadge({ task }) {
  const { mode, attempts, now } = useAutoContinueState();
  const info = getBadgeInfo(task, attempts[task.task_id], mode, now);
  if (!info) return null;
  return (
    <span
      data-testid="auto-continue-badge"
      style={{
        ...tones[info.tone],
        display: 'inline-flex',
        alignItems: 'center',
        padding: '3px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 500,
        textAlign: 'left',
      }}
    >
      {info.text}
    </span>
  );
}
